module.exports = __webpack_public_path__ + "static/media/risk.01c012c7.svg";